import { ChatCircle, TrendUp, UserCirclePlus } from '@phosphor-icons/react';

const STEPS = [
  {
    number: 1,
    icon: ChatCircle,
    title: 'Tell Romy what\'s going on',
    description: 'Chat naturally about symptoms, treatments, or concerns — no forms, no jargon',
  },
  {
    number: 2,
    icon: TrendUp,
    title: 'She learns your patterns over time',
    description: 'Romy remembers your history, detects correlations, and surfaces insights from 1,000+ clinical sources',
  },
  {
    number: 3,
    icon: UserCirclePlus,
    title: 'Get smarter care, every visit',
    description: 'Walk into appointments with evidence, advocacy letters, and a companion who knows your full story',
  },
];

export default function HowItWorks() {
  return (
    <section className="py-12 sm:py-16">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-800 dark:text-gray-100 text-center mb-10 sm:mb-14">
          How It Works
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 sm:gap-10">
          {STEPS.map(({ number, icon: Icon, title, description }) => (
            <div key={number} className="flex flex-col items-center text-center">
              <div className="relative mb-4">
                <div className="w-16 h-16 rounded-full bg-pink-100 dark:bg-pink-900/40 flex items-center justify-center">
                  <Icon size={28} className="text-pink-500" weight="fill" />
                </div>
                <span className="absolute -top-1 -right-1 w-6 h-6 rounded-full bg-gradient-to-r from-orange-500 to-pink-500 text-white text-xs font-bold flex items-center justify-center">
                  {number}
                </span>
              </div>
              <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-100 mb-2">
                {title}
              </h3>
              <p className="text-sm text-gray-600 dark:text-gray-400 max-w-xs">
                {description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
